<div class="center-details-modal">
  <!-- Header Section -->
  <div class="modal-header">
  
    <h2 class="modal-title">Center Details</h2>
    <p class="modal-subtitle">Please fill in the details below.</p>
</div>
{{this.data | json}}
<br>
{{centerForm.value| json}}
<!-- Form Section -->
<div class="modal-body">
    <form [formGroup]="centerForm" class="center-form">
      <div class="form-grid">
        <!-- Center Name - Highlighted, read-only banner -->
        <div class="form-row-full">
          <div class="center-name-banner" [title]="centerName">
            {{ centerName || 'Center Name' }}
          </div>
        </div>

        <!-- APP Name, AOC Name, COC Name - Three Column Row -->
        <div class="form-row-three">
          <div class="form-field">
            <label class="field-label">APP (Area Point Person) Name <span class="text-danger">*</span></label>
            <ng-select 
              [items]="appList" 
              [searchable]="true"
              formControlName="APPId" 
              bindLabel="FirstName" 
              bindValue="Id" 
              placeholder="Select APP Name"
              (search)="onAPPSearchInput($event)" 
              (clear)="onAPPClear()" 
              class="custom-ng-select">
            </ng-select>
            <div class="error-message" *ngIf="submitted && centerForm.controls['APPId'].invalid">
              APP Name is required
            </div>
          </div>
          
          <div class="form-field">
            <label class="field-label">AOC (Area operations Coordinator) Name <span class="text-danger">*</span></label>
            <ng-select 
              [items]="aocList" 
              [searchable]="true"
              formControlName="AOCId" 
              bindLabel="FirstName" 
              bindValue="Id" 
              placeholder="Select AOC Name"
              (search)="onAOCSearchInput($event)" 
              (clear)="onAOCClear()" 
              class="custom-ng-select">
            </ng-select>
            <div class="error-message" *ngIf="submitted && centerForm.controls['AOCId'].invalid">
              AOC Name is required
            </div>
          </div>
          
          <div class="form-field">
            <label class="field-label">COC (Center operations Coordinator) Name <span class="text-danger">*</span></label>
            <ng-select 
              [items]="cocList" 
              [searchable]="true"
              formControlName="COCId" 
              bindLabel="FirstName" 
              bindValue="Id" 
              placeholder="Select COC Name"
              (search)="onCOCSearchInput($event)" 
              (clear)="onCOCClear()" 
              class="custom-ng-select">
            </ng-select>
            <div class="error-message" *ngIf="submitted && centerForm.controls['COCId'].invalid">
              COC Name is required
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Action Buttons -->
  <div class="modal-footer">
    <button class="btn-cancel" (click)="cancel()">CANCEL</button>
    <button class="btn-save" (click)="saveCenter()">SAVE</button>
  </div>
</div>